import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { BackgroundImage } from '../../../../atoms'

interface DefaultHeaderProps {
  label: string
  image: React.ReactNode
  className?: string
}

const DefaultHeader = ({ label, image, className }: DefaultHeaderProps) => {
  return (
    <div className={clsx(s.serviceHeader, className)}>
      <div className={s.contentService}>
        <div className={s.imageService}>
          {typeof image === 'string' ? (
            <BackgroundImage
              src={image}
              style={{ borderRadius: '5px' }}
              type='cover'
              alt={label}
            />
          ) : (
            <div className={s.image}>{image}</div>
          )}
        </div>
        <div className={s.containerInformations}>
          <h4 className={s.name}>{label}</h4>
        </div>
      </div>
    </div>
  )
}
export default DefaultHeader
